import { css } from '@emotion/css';

export const styWrapper = css`
  overflow: hidden;
`;

export const styTable = css`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
`;

export const stySentinel = css`
  height: 1px;
  width: 100%;
`;
